import {
  workspace_v1_WorkspaceConfig,
  workspaceV1PutConfigMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useUpdateWorkspaceConfig = () => {
  const { workspace } = useWorkspace();
  return useMutation({
    mutationFn: (data: workspace_v1_WorkspaceConfig) =>
      workspaceV1PutConfigMutation({
        ...defaultOptions(),
      }).mutationFn!({ body: data, path: { workspace } }),
  });
};
